<template>
    <div class="box">
        Already completed this form?<br />Enter your email address to check in
        using your information.
        <div class="field has-addons">
            <p class="control is-expanded">
                <input
                    class="input"
                    type="text"
                    placeholder="search by email address"
                    v-model="email"
                />
            </p>
            <p class="control">
                <a class="button is-info" @click="search">
                    Search
                </a>
            </p>
        </div>
        <div
            class="is-danger help search-email-help"
            vi-if="searchEmailHelp.length"
            v-text="searchEmailHelp"
        ></div>
    </div>
</template>
<script>
var validator = require("email-validator");
export default {
    methods: {
        search() {
            if (this.email.length && validator.validate(this.email)) {
                this.searchEmailHelp = "";
                var _self = this;
                axios
                    .post("/api/property/" + slug + "/searchEmail", {
                        email: this.email
                    })
                    .then(function(response) {
                        if (response.data.success === 0) {
                            _self.searchEmailHelp = response.data.message;
                        } else if (typeof response.data.signup == "object") {
                            _self.searchEmailHelp = "";
                            _self.$emit("fill", response.data.signup);
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            } else {
                this.searchEmailHelp = "Invalid Email";
            }
        }
    },
    data() {
        return {
            email: "",
            searchEmailHelp: ""
        };
    }
};
</script>
